module.exports = __webpack_public_path__ + "img/zh.2343447c.svg";